<template lang="pug">
.inspiration-popup
    a-spin(:spinning="spinning")
        div.header-title
            b {{ LANG.INSPIRATION }}
            span.desc {{ LANG.INSPIRATION_DESC }}

        div.header-tags
            a(v-for="t in tags"
                :class="{selected: tag === t.slug}" @click="selectTag(t.slug)") {{ t.title }}

        div.message-item(v-on:scroll="scroll($event)")
            a(v-for="mess in messages" @click="selected = mess.id; message = mess.text" :class="{selected: mess.id === selected}" v-html="formatText(mess.text)")

        div.message-footer
            button(@click="saveChange") {{ LANG.SAVE_MESSAGE }}
</template>

<style lang="scss">
.inspiration-popup {
    a {
        color: #000;
    }
    .message-footer {
        @media(max-width: 991px) {
            box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
            margin-left: -25px;
            padding-left: 25px;

            margin-right: -25px;
            padding-right: 25px;
            padding-top: 20px;
        }
        button {
            width: 100%;
            height: 48px;
            background-color: #D8B869;
            color: #000;
            border: none;
        }
    }
    .header-title {
        font-size: 14px;
        line-height: normal;
        b {
            display: block;
            font-size: 18px;
        }
    }
    .message-item {
        margin-top: 15px;
        border-bottom: 1px solid #DADADA;
        max-height: 300px;
        min-height: 100px;
        overflow-y: auto;

        a {
            display: block;
            padding: 20px 15px;
            text-align: center;
            border-top: 1px solid #DADADA;
            font-size: 14px;
            img {
                height: 14px;
            }
            &.selected {
                color: #D8B869;
            }
        }

        @media(max-width: 991px) {
            border-bottom: none;
            margin-left: -24px;
            margin-right: -24px;
            a {
                padding-left: 25px;
                padding-right: 25px;
            }
        }
    }
    .header-tags  {
        margin-top: 15px;
        display: flex;
        margin-left: -5px;
        margin-right: -5px;
        flex-wrap: wrap;
        a {
            margin: 5px;
            padding: 0 15px;
            height: 32px;
            border: 1px solid #D8B869;
            line-height: 30px;
            display: block;

            &.selected {
                background-color: #D8B869;
            }

            // @media(max-width: 991px) {
            //     border-color: #505050;
            //     color: #505050;

            //     &.selected {
            //         border-color: #D8B869;
            //         color: #505050;
            //     }
            // }
        }
    }


}
</style>

<script>

import {getCurrentInstance, inject} from "vue";

export default {
	name: "Inspiration",
	props: {
        poster_style: {
            type: String
        }
	},
	data() {
		return {
            selected: '',
            tag: '',
            message: '',
            tags: [],
            messages: [],
            spinning: false,
            page: 1
		}
	},

    mounted() {
	    this.spinning = true;

        fetch(this.endpoint)
        .then(response => response.json())
        .then(data => {
            this.spinning = false;
            this.tags = data.tags;
            this.messages = data.results
            this.tag = data.tag_current
        });
    },
    computed: {
	    endpoint() {
	        return `${nse_config.api_endpoint.inspiration}?editor=${window.nse_config.editor}&tags=${this.tag}&page=${this.page}&style=${this.poster_style}&language=${nse_config.language}`
        }
    },
    methods: {
        selectTag(tag) {
            this.tag = tag;
            this.messages = [];
            this.page = 1;
            this.fetchMess();
        },
        scroll(event) {
            var stop = event.target.scrollTop;
            var s = event.target.scrollHeight - event.target.clientHeight;

            if (stop / s >= 0.9 && !this.spinning && !!this.page) {
                this.fetchMess();
            }
        },

        fetchMess() {
            this.spinning = true;
            fetch(this.endpoint)
                .then(response => response.json())
                .then(data => {
                    data.results.map(item => this.messages.push(item));
                    this.spinning = false;
                    this.page = data.next;
                });
        },
        formatText(str ) {
            var appContext = getCurrentInstance();

            const $nl2br = inject('$nl2br');
            return $nl2br(str)
        },
        saveChange() {
            this.$emit('input', this.message)
            this.message = '';
            this.selected = '';
            this.tag = '';
        }
    }
}
</script>
